import { PrinterIcon } from './PrinterIcon';

/**
 * author: Google
 * id 7365D689-4C10-4EBA-AD9A-09189B8091EE
 * name printer
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/printer.svg
 * tags
 * - Printer 
 * - Home Automation 
 */
export const LocalPrintshopIcon = PrinterIcon;
export default LocalPrintshopIcon